
import { Component, EventEmitter } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import {  OnInit } from '@angular/core';


import { Progress } from './components/utils';
@Component({
  selector: 'appc-donate',
  templateUrl: './donate.component.html',
  styleUrls: ['./donate.component.scss']
})
export class DonateComponent implements OnInit {

  donate: number[] = [];
  donors: number = 42;
  goal: number = 350000;
  raised: number = 250000;
  title: string = 'Donate';

  constructor() { }

  ngOnInit(){

  }

  get balance(): number {
    return Math.max(0, this.goal - this.raised)
  }

  get progress(): Progress {
    return {
      goal: this.goal,
      raised: this.raised
    }
  }  

  save(value: number) {
    this.donate.push(value)
    console.log(this.donate)
  }

  submit(event: EventEmitter<any>) {
    if (typeof event === 'number') this.updateDonation(event)
  }

  updateDonation(value: number) {
    this.raised = this.raised + value
    this.donors++
  }
}




// WEBPACK FOOTER //
// /Volumes/Projects/dev2/ng2fb-bootstrap/src/app/main/donate/donate.component.ts